import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/build/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/build/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/aspect-ratio.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BannerClient"] */ "/build/src/components/layout/banner/banner-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/layout/cookie-consent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/layout/cookies/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/layout/footer/footer-submenu-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/src/components/layout/nav/nav-menu-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkTrackers"] */ "/build/src/components/reusables/link-trackers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AspectRatio"] */ "/build/src/components/ui/aspect-ratio.tsx");
